module.exports = __webpack_public_path__ + "img/Connection Icon V2.26d4fd24.png";